import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import Tooltip from './Tooltip';
import OverlayTrigger from '../overlay/OverlayTrigger';
import { PLACEMENT } from '../../values/Placement';
import { TRIGGER } from '../../values/Trigger';
const SimpleTooltip = (props) => {
    const { children, placement = PLACEMENT.AUTO, trigger, content, delay, popperConfig, targetRef } = props, remainingProps = __rest(props, ["children", "placement", "trigger", "content", "delay", "popperConfig", "targetRef"]);
    return (_jsx(OverlayTrigger, Object.assign({ placement: placement, trigger: trigger, overlay: _jsx(Tooltip, Object.assign({}, remainingProps, { ref: targetRef }, { children: content })), delay: delay, popperConfig: popperConfig }, { children: children })));
};
SimpleTooltip.TRIGGER_CLICK = TRIGGER.CLICK;
SimpleTooltip.TRIGGER_HOVER = TRIGGER.HOVER;
SimpleTooltip.TRIGGER_FOCUS = TRIGGER.FOCUS;
export default SimpleTooltip;
